import React, { useContext } from "react";
import Layout from "../../components/layout/Layout";
import ProductsHeroBanner from "../../components/productsHeroBanner";
import Products from "../../components/ourProducts";
import { LanguageContext } from "../../context/LanguageContext"

function OurProducts() {
  const { data } = useContext(LanguageContext);
  return (
    <Layout>
      {/* for become a supplier */}
      <ProductsHeroBanner />
      <Products products={data.ourProducts.map((products) => products)} />
    </Layout>
  );
}

export default OurProducts;
